import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as CropActions from '../_actions/crop';
import { Crop } from '../_models';

export interface CropState extends EntityState<Crop> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Crop> = createEntityAdapter<Crop>();

const initialState: CropState = adapter.getInitialState({
  loading: false,
  error: null,
});

const cropReducer = createReducer(
  initialState,

  on(CropActions.loadCrops, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(CropActions.loadCropsSuccess, (state, { crops }) =>
    adapter.setAll(crops, { ...state, loading: false })
  ),

  on(CropActions.loadCropsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(CropActions.addCropSuccess, (state, { crop }) => adapter.addOne(crop, state)),

  on(CropActions.updateCropSuccess, (state, { crop }) => adapter.upsertOne(crop, state)),

  on(CropActions.deleteCropSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(CropActions.mergeCropsSuccess, (state, { crops }) => adapter.upsertMany(crops, state)),

  on(
    CropActions.addCropFailure,
    CropActions.updateCropFailure,
    CropActions.deleteCropFailure,
    CropActions.mergeCropsFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: CropState | undefined, action: Action) {
  return cropReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
